export const DEFAULT_DATE_PICKER_FORMAT = 'dd-MM-yyyy';
